const styles = (theme) => ({
  discoverFormContainer: {
    alignItems: "center",
    width: "100%",
    maxWidth: "600px",
  },
})

export default styles
